import { Component, OnInit, Output, Input, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataBindingDirective, GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { HttpClient } from '@angular/common/http';
import { FilterDescriptor, orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CheckoutService } from '../../../core/services/checkout.service';
import { AddressType, ICountry, ICustomer, ICustomerAddress, ICustomerArchiveAddress, ICustomerAddressLabel, IMasterData, IState, CustomerAddress } from 'src/app/core/models';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { Info } from '../../../core/common';
import { sortBy, sortedIndexBy } from 'lodash';
//import { debug } from 'console';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-customer-address',
  templateUrl: './customer-address.component.html',
  styleUrls: ['./customer-address.component.scss']
})
export class CustomerAddressComponent implements OnInit {
  @Input() hideShippingAddrGrid: boolean;
  @Output() public hideShippingAddr: EventEmitter<boolean> = new EventEmitter();
  lblText: ICustomerAddressLabel;
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();
    currentZipCode: string;
  scrHeight: any;
  scrWidth: any;
  isMobileOrTab: boolean;
  public showValidationInfo: boolean;
  public inputValidationMessage: string = "Only following special characters are allowed: Comma(,), Dash(-) and Dot(.)";
  public isDisabled: boolean;
  public customerArchiveObj: ICustomerArchiveAddress = {
    customerNumber: null,
    isActive: false,
    isDefault: false,
    updateInProgress: false
  };
  constructor(
    private customerService: CustomerService,
    private masterDataService: MasterDataService,
    private userService: UserService,
    private checkoutService: CheckoutService, private languageTranslationService: LanguageTranslationService) {
    this.getScreenSize();
  }
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;   
    if (this.scrWidth <= 1024) {
      this.isMobileOrTab = true;
    }
    else {
      this.isMobileOrTab = false;
    }
  }

  ngOnInit() {
    this.loadLanguageTranslationData();    

    this.addShippingForm = this.addShippingFormGroup();
    this.gridSettings.gridLoading = true;
    this.customerService.getAllAddressList().pipe(tap((customers: ICustomer[]) => {
      this.customerService.addressList = customers as ICustomer[];
    })).subscribe((customers: ICustomer[]) => {
      //this.customarAddress.addressList = customers as ICustomer[];//remove it
      this.loadAddress();
      this.gridSettings.gridLoading = false;
      this.setDefaultAddress();
    });

    this.masterDataService.GetCountries().pipe(tap((countries: ICountry[]) => {
      this.masterDataService.countries = countries as ICountry[];
      //if (countries) {
      //  if (countries.length > 0) {
      //    this.masterDataService.states = countries[0].states as IState[];
      //  }
      //}
    })).subscribe((countries: ICountry[]) => {
      this.addShippingDialog.countries = countries as ICountry[];
    })

  }
  //#region Language translate
  loadLanguageTranslationData() {
    //need to add remaining fields
    const controlNameList = [
      { controlName: "addAddressLbl" },
      { controlName: "addressLine1Lbl" },
      { controlName: "addressLine2Lbl" },
      { controlName: "cityLbl" },
      { controlName: "manageAddressLbl" },
      { controlName: "nameLbl" },
      { controlName: "shipToLbl" },
      { controlName: "stateLbl" },
      { controlName: "zipcodeLbl" },
      { controlName: "shippingAddressLbl" },
      { controlName: "selectAddressLbl" },
      { controlName: "duplicateAddressText1" },
      { controlName: "duplicateAddressText2" },
      { controlName: "duplicateAddressText3" },
      { controlName: "addNewAddressLbl" },
      { controlName: "closeLbl" },
      { controlName: "selectLbl" },
      { controlName: "archiveSelectLbl" },
      { controlName: "phoneValidationLbl" },
      { controlName: "countryLbl" },
      { controlName: "countyLbl" },
      { controlName: "phoneNumberLbl" },
    ];
    const componentName = "customer-address";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.lblText = response[response.length - 1];
    }
    console.log(response);
  }

  //#endregion
  //#region customarAddress Variable Declaration & Operations

  public setDefaultAddress() {
    if (this.checkoutService.checkOutProcessModel.currentShipping) {
      this.checkoutService.checkOutProcessModel.currentShipping.isSelected = false;
    }
    if (this.customarAddressGridView.data.length > 0) {
      //deafult select the 1st one in the list as shipping address
      let selectedShippingAddress = this.customarAddressGridView.data[0];
      if (this.checkoutService.checkOutProcessModel.currentShipping) {
        if (this.checkoutService.checkOutProcessModel.currentShipping.customerNumber) {
          const tempCustomernumber = this.checkoutService.checkOutProcessModel.currentShipping.customerNumber;
          const tempCustomer = this.customerService.getAddressList.find(r => r.customerNumber === tempCustomernumber && r.isActive);//if default is archived then first row selected
          if (tempCustomer) {
            tempCustomer.isSelected = true;
            selectedShippingAddress = tempCustomer;
          }
        }
      }
      else {
        const defaultAddress = this.customerService.getAddressList.find(r => r.isDefault === true);
        if (defaultAddress) {
          selectedShippingAddress = defaultAddress;
          defaultAddress.isSelected = true;
        }
      }
      
      selectedShippingAddress.isSelected = true;
      this.checkoutService.checkOutProcessModel.currentShipping = selectedShippingAddress;
      this.checkoutService.checkOutProcessModel.shipToCustomerNumber = selectedShippingAddress.customerNumber;


      //fire Ship To Change event
     /* console.log(selectedShippingAddress);*/
      this.checkoutService.shipToChangeSubject.next(selectedShippingAddress);//bad one not working

      //set billing address
      const selectedBillingAddress = this.customerService.getAddressList
        .find(r => (r.billingType === AddressType.Both || r.billingType == AddressType.Billing) && r.isActive && r.customerNumber === +this.userService.readUserObject.customerNumber)
      if (selectedBillingAddress) {
        this.checkoutService.checkOutProcessModel.currentBilling = selectedBillingAddress;
        this.checkoutService.checkOutProcessModel.billToCustomerNumber = selectedBillingAddress.customerNumber;
      }
    }
    //this.loadAddress();??????? function is use to set default ? why load again??
  }

  public customarAddress = {
    addAddressLbl: 'Add New Shipping Address',
    manageAddressLbl: 'Manage Addresses',
    customerNumberLbl: 'Customer Number',
    nameLbl: 'Mailing Name',
    addressLine1Lbl: 'Address Line 1',
    addressLine2Lbl: 'Address Line 2',
    cityLbl: 'City',
    stateLbl: 'State',
    zipcodeLbl: 'Zip Code',
    countryLbl: 'Country',
    countyLbl: 'County',
    phoneNumberLbl: 'Phone Number',
    shippingAddressLbl: 'Shipping Address',
    selectAddressLbl: 'Select Address',
    duplicateAddressText1: 'We found similar addresses at the',
    duplicateAddressText2: 'you entered, you can either select address from the table below or click on',
    addNewAddressLbl: 'Add New Address',
    duplicateAddressText3: 'to create new address and customer',
    closeLbl: 'Close',
    selectLbl: 'Select',
    archiveSelectLbl: 'Unarchive & Select',
    phoneValidationLbl: 'Phone number length should be minimum 10',
    addressList: [],
    customarAddressGrid: {
      addressList: []
    },
    changeAddressText: "Change Shipping Address",
    hideShippingAddressText: "Hide Shipping Addresses"
  };

  public get f() {
    return this.addShippingForm.controls;
  }
  //#endregion
  //#region customarAddress kendo-grid Events & Operations
  public customarAddressGridView: GridDataResult

  public addShippingForm: FormGroup;

  public gridSettings = {
    pageSizes: [10, 20, 30, 40, 50],
    gridLoading: false
  };

  public addressGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: '',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  defaultSort = [{
    field: '',
    dir: 'desc'
  }];

  public loadAddress(): void {
    let shippingaddressList = this.customerService.getAddressList.filter((address: ICustomer) =>
      (address.billingType === AddressType.Shipping || address.billingType === AddressType.Both) && address.isActive);
    //shippingaddressList = sortBy(shippingaddressList, ['isDefault']);
    var deftAddr = shippingaddressList.find(x => x.isSelected || x.isDefault);//Will always return default not the selected one
    var deftAddrIndex = shippingaddressList.findIndex(x => x.isSelected || x.isDefault);
    if (this.checkoutService.checkOutProcessModel.currentShipping && this.checkoutService.checkOutProcessModel.currentShipping.customerNumber) {
      const tempCustomernumber = this.checkoutService.checkOutProcessModel.currentShipping.customerNumber;
      deftAddr = this.customerService.getAddressList.find(r => r.customerNumber === tempCustomernumber && r.isActive);
      deftAddrIndex = shippingaddressList.findIndex(r => r.customerNumber === tempCustomernumber && r.isActive);
    }
    if (deftAddr) {
      shippingaddressList.splice(deftAddrIndex, 1);
      shippingaddressList.splice(0, 0, deftAddr);      
    }
    this.customarAddressGridView = process(shippingaddressList, this.addressGridstate);
  }

  public customerAddressGridSortChange(sort): void {
    this.addressGridstate.sort = sort;
    this.loadAddress();
  }

  public customerAddressGridPageChange({ skip, take }: PageChangeEvent): void {
    this.addressGridstate.skip = skip;
    this.addressGridstate.take;
    this.loadAddress();
  }

  public customerAddressDataStateChange(state: DataStateChangeEvent): void {
    this.addressGridstate = state;
    this.loadAddress();
  }

  public selectExistingShippingAddress(dataItem: ICustomer): void {
    console.log("dataitem: ", dataItem);
    this.selectShippingAddress(dataItem);

    this.setCustomerArchiveObj(dataItem);
    this.customerService.archiveAddress(this.customerArchiveObj).subscribe((archiveAddrStatus) => {
      console.log(archiveAddrStatus); // always returns "archived", hardcoded
    });

    this.loadAddress();
    this.setDefaultAddress();
    this.addShippingDialogClose(); // close after selecting addrs from zipcode check list
  }


  public selectShippingAddress(dataItem: ICustomer): void {
    //find existing selected address and unselect it
    this.checkoutService.checkOutProcessModel.currentShipping.isSelected = false;
    dataItem.isSelected = true;
    this.checkoutService.checkOutProcessModel.currentShipping = dataItem;
    this.checkoutService.checkOutProcessModel.shipToCustomerNumber = dataItem.customerNumber;
    const tempCustomer = this.customerService.getAddressList.find(r => r.customerNumber === dataItem.customerNumber);
    tempCustomer.isSelected = true;
    this.customerService.getAddressList.filter(r => r.customerNumber !== dataItem.customerNumber).forEach((item, index) => {
      item.isSelected = false;
    });

    //if (this.addShippingDialog.opened) {
    //  //this.addShippingDialogClose();
    //  this.duplicateAddressList = [];
    //}
    if (this.isMobileOrTab) {
      this.hideShippingAddrGrid = true;
      this.hideShippingAddr.emit(true);
    }

    //fire Ship To Change event
    //console.log(dataItem);
    this.checkoutService.shipToChangeSubject.next(dataItem);//good one

  }

  //#endregion

  public suggestionAddressGrid = true;
  public duplicateAddressList = [];
  public duplicateAddressCheck(addShippingForm: ICustomer) {
    if (!addShippingForm.state) addShippingForm.state = "";
    if (!addShippingForm.zipCode) addShippingForm.zipCode = "";
    this.duplicateAddressList = this.customerService.getAddressList
      .filter(r =>r.zipCode == addShippingForm.zipCode);
  }
  public jobSearchGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'addressLine1',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public jobSearchGridSettings = {
    gridLoading: true
  };
  //#region Manage Shipping Address Dialog
  public manageAddressDialog = {
    opened: false,
  }
  public manageAddressDialogClose() {
    this.manageAddressDialog.opened = false;
    //this.addressGridstate.sort = [{
    //  field: 'customerNumber',
    //  dir: 'desc'
    //}];
    this.loadAddress();
    this.setDefaultAddress();
  }
  public manageAddressDialogOpen() {
    this.manageAddressDialog.opened = true;
  }
  //#endregion
  //#region Add Shipping Address Dialog
  public addShippingDialog = {
    opened: false,
    loading: false,
    defaultState: { name: 'Select State', value: null } as IMasterData,
    defaultCountry: { name: 'Select Country', value: null } as IMasterData,
    states: [] as IState[],
    countries: [] as ICountry[],
    isSubmitted: false,
    isInvalidCustomerName: false,
    isInvalidAddressLine1: false,
    isInvalidAddressLine2: false,
    isInvalidCity: false,
    isInvalidCountry: false,
    isInvalidState: false,
    isInvalidZipCode: false,
    isInvalidCounty: false,
    isInvalidPhoneNumber: false,
    isInvalidPhoneNumberMessage: false,
    isValidForm: this.validateAddShippingForm()
  };
  public resetAddShippingForm() {
    this.addShippingDialog.isInvalidCustomerName = false,
      this.addShippingDialog.isInvalidAddressLine1 = false,
      this.addShippingDialog.isInvalidAddressLine2 = false,
      this.addShippingDialog.isInvalidCity = false,
      this.addShippingDialog.isInvalidCountry = false,
      this.addShippingDialog.isInvalidState = false,
      this.addShippingDialog.isInvalidZipCode = false,
      this.addShippingDialog.isInvalidCounty = false,
      this.addShippingDialog.isInvalidPhoneNumber = false,
      this.addShippingDialog.isInvalidPhoneNumberMessage = false;
    this.addShippingDialog.isValidForm = this.validateAddShippingForm();
    this.addShippingDialog.loading = false;
    this.addShippingDialog.isSubmitted = false;
    this.addShippingForm.reset();
    this.duplicateAddressList = [];
    this.doDuplicateAddressCheck = true;
  }
  public validateAddShippingForm(): boolean {

    let isValid = true;
    if (!this.addShippingDialog) {
      return;
    }
    if (this.addShippingDialog.isSubmitted) {


      if (this.f.customerName.value) {
        this.addShippingDialog.isInvalidCustomerName = false;
      } else {
        this.addShippingDialog.isInvalidCustomerName = true;
        isValid = false;
      }

      if (this.f.addressLine1.value) {
        this.addShippingDialog.isInvalidAddressLine1 = false;
      } else {
        this.addShippingDialog.isInvalidAddressLine1 = true;
        isValid = false;
      }

      if (this.f.city.value) {
        this.addShippingDialog.isInvalidCity = false;
      } else {
        this.addShippingDialog.isInvalidCity = true;
        isValid = false;
      }

      if (this.f.country.value) {
        this.addShippingDialog.isInvalidCountry = false;
      } else {
        this.addShippingDialog.isInvalidCountry = true;
        isValid = false;
      }

      if (this.f.state.value) {
        this.addShippingDialog.isInvalidState = false;
      } else {
        this.addShippingDialog.isInvalidState = true;
        isValid = false;
      }

      if (this.f.zipCode.value) {
        this.addShippingDialog.isInvalidZipCode = false;
      } else {
        this.addShippingDialog.isInvalidZipCode = true;
        isValid = false;
      }

      if (this.f.phoneNumber.value) {

        this.addShippingDialog.isInvalidPhoneNumber = false;
        if ((this.f.phoneNumber.value as string).toString().length !== 10) {
          this.addShippingDialog.isInvalidPhoneNumber = true;
          this.addShippingDialog.isInvalidPhoneNumberMessage = true;
          isValid = false;
        } else {
          this.addShippingDialog.isInvalidPhoneNumber = false;
          this.addShippingDialog.isInvalidPhoneNumberMessage = false;
        }

      } else {
        this.addShippingDialog.isInvalidPhoneNumber = true;
        isValid = false;
      }
    }
    return isValid;
  }
  doDuplicateAddressCheck: boolean = true;
  statusCheck() {
    if (this.currentZipCode != this.f.zipCode.value) {
      this.doDuplicateAddressCheck = true;
    }
  }
  public addNewShippingHandler(event, addShippingForm: ICustomer) {
    this.currentZipCode = addShippingForm.zipCode;
    this.infoMessage = new Info();
    this.addShippingDialog.isSubmitted = true;
    this.validateAddShippingForm();
    if (this.validateAddShippingForm()) {  //checking whether add customer popup form is valid or not
      this.isDisabled = true;

      if (this.doDuplicateAddressCheck) {
        this.duplicateAddressCheck(addShippingForm);
        this.doDuplicateAddressCheck = false;
        if (this.duplicateAddressList.length > 0) {

          this.isDisabled = false;
          return;
        }
          
      }

      this.inProgressMessage = true;
      this.saveInProcess = true;
      this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
      addShippingForm.phoneNumber.toString();
      const body = {
        addressLine1: addShippingForm.addressLine1,
        addressLine2: addShippingForm.addressLine2,
        city: addShippingForm.city,
        country: addShippingForm.country,
        county: addShippingForm.county,
        customerName: addShippingForm.customerName,
        parentCustomerNumber: addShippingForm.parentCustomerNumber,
        parentCustomerName: this.userService.readUserObject.customerName,
        phoneNumber: addShippingForm.phoneNumber.toString(),
        state: addShippingForm.state,
        zipCode: addShippingForm.zipCode

      }

      this.customerService.addShippingAddress(body as ICustomer)
        .subscribe((customer: ICustomer) => {
          this.infoMessage.genericInProgress = "";
          this.saveInProcess = false;
          if (customer) {
            this.customerService.addAddressToList(customer);
            //need to comment, to make newaddress on first line
            //this.addressGridstate.sort = [{
            //  field: '',
            //  dir: 'asc'
            //}];

            //this.loadAddress();
            //this.setDefaultAddress();
            this.selectShippingAddress(customer);
            let shippingaddressList = this.customerService.getAddressList.filter((address: ICustomer) =>
              (address.billingType === AddressType.Shipping || address.billingType === AddressType.Both) && address.isActive);

            //make the newly added shipping address in first row
            const newAddr = shippingaddressList.find(x => x.customerNumber == customer.customerNumber);
            const newAddrIndex = shippingaddressList.findIndex(x => x.customerNumber == customer.customerNumber);
            if (newAddr) {
              shippingaddressList.splice(newAddrIndex, 1);
              shippingaddressList.splice(0, 0, newAddr);
              this.customarAddressGridView = process(shippingaddressList, this.addressGridstate);
            }

            //show status
            this.infoMessage.genericSuccess = "New shipping address " + customer.customerNumber + " saved.";
          } else {
            ///show status
            this.infoMessage.genericError = this.infoMessage.errorMessage;
          }
          this.isDisabled = false;
         this.resetAddShippingForm();
        })
      }
  }

  public addShippingFormGroup() {
    return new FormGroup({
      customerName: new FormControl(""),
      addressLine1: new FormControl(""),
      addressLine2: new FormControl(""),
      city: new FormControl(""),
      state: new FormControl(""),
      zipCode: new FormControl(""),
      country: new FormControl(""),
      county: new FormControl(""),
      phoneNumber: new FormControl("")
    });
  }

  public addShippingDialogClose() {
    this.addShippingDialog.opened = false;
    this.addShippingDialog.isSubmitted = false;
    this.addShippingForm = this.addShippingFormGroup();
    //this.loadAddress();
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.duplicateAddressList = [];
    this.doDuplicateAddressCheck = true;
  }
  public addShippingDialogCountySelectionChange(event) {
    //const selectedCounty = this.f.country.value;
    console.log(event);
    console.log(this.f.country.value);
    if (event) {
      this.addShippingDialog.states = event.states;
    }

    this.validateAddShippingForm();
  }
  addShippingDialogStateSelectionChange(value) {
    if (value.stateCode) {

    }
    this.validateAddShippingForm();
  }
  public addShippingDialogOpen() {
    this.addShippingDialog.opened = true;
    this.addShippingDialog.isSubmitted = false;
  }


  //is genereic, is empty(control, type){if type is input/textbox, control.value.trm--> }

  public onFilter(inputValue: string): void {
    let shippingaddressList = this.customerService.getAddressList.filter((address: ICustomer) =>
      (address.billingType === AddressType.Shipping || address.billingType === AddressType.Both) && address.isActive);
    this.customarAddressGridView = process(shippingaddressList, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "customerNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "mailingName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "customerName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "addressLine1",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "city",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "zipCode",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "phoneNumber",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.addressGridstate.skip = 0;
      this.addressGridstate.take = 10;
      this.loadAddress();
    }
    //this.dataBinding.skip = 0;
  } 
  public showInfo(event: boolean) {
    if (!event)
      this.showValidationInfo = true;
    else
      this.showValidationInfo = false;
    //console.log("Only following special character allowed: , - .");
  }

  public setCustomerArchiveObj(dataItem: ICustomer) {
    
    dataItem.isActive = true;
    this.customerArchiveObj.customerNumber = dataItem.customerNumber;
    this.customerArchiveObj.isDefault = false; // not needed
    this.customerArchiveObj.updateInProgress = true; // not needed
    this.customerArchiveObj.isActive = dataItem.isActive;
    console.log("customer archive obj after set: ", this.customerArchiveObj);

  }


}
